import { Button } from 'components/button/Button';
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal, openModal } from 'reducers/modal';
import * as Yup from 'yup';
import { Spinner } from 'components/spinner/Spinner';
import { TextArea } from 'components/formFields/TextArea';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';

export const VirtualAssessmentsAdjustmentModal = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation(
    ['Virtual+Assessments+Adjustment+Modal', 'Panel+Buttons'],
    { i18n }
  );


  const handleSubmit = (values: { note: string | null }) => {
    console.log('values', values);
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const validationSchema = Yup.object({
    note: Yup.string()
      .required(t('SSCandidate_Virtual_Assessments_Adjustment_Modal_Reason_Required'))
      .typeError(t('SSCandidate_Virtual_Assessments_Adjustment_Modal_Reason_Required')),
  });


  return (
    <div className="VirtualAssessmentsAdjustmentModal">
      <Formik
        initialValues={{ note: '' }}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {({ isValid, isSubmitting, values, setFieldValue }) => (
          <Form>
            <div className="VirtualAssessmentsAdjustmentModal__content VirtualAssessmentsModalContent Content">
              <div>
                <div className="VirtualAssessmentsAdjustmentModal__title">
                  {t('SSCandidate_Virtual_Assessments_Adjustment_Modal_Title')}
                </div>

                <div className="Paragraph">
                  {t(
                    'SSCandidate_Virtual_Assessments_Adjustment_Modal_Are_You_Sure'
                  )}
                </div>
              </div>
               <div className="SJTAdjustmentModal__textinput">
                  <TextArea
                    label={t(
                      'SSCandidate_Virtual_Assessments_Adjustment_Modal_Additional_Notes'
                    )}
                    name="note"
                    charLimit={100}
                  />
                </div>
            </div>
            <div className="ModalFooter">
              <Button
                priority="tertiary"
                type="button"
                onClick={handleCloseModal}
              >
                {t('SSCandidate_Panel_Buttons_Cancel', { ns: 'Panel+Buttons' })}
              </Button>
              <Button
                className="Discard"
                priority="primary"
                type="submit"
                onClick={() => {}}
              >
                {t('SSCandidate_Panel_Buttons_Submit', { ns: 'Panel+Buttons' })}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
